<template>
  <div>

    <form @submit.prevent="submit">
      <p class="text-muted">Informe seu e-mail para recuperar sua senha</p>

      <div class="form-group mb-5">
        <FloatingLabel type="email" input-class="form-control form-control-xl bg-white border-blue-br" label="E-mail" v-model="email" />
      </div>

      <div class="text-center">
        <a href="#" class="text-black-50 font-weight-bold mr-3" @click.prevent="$emit('changeModal', 'login')">Voltar para Login</a>
        <button type="submit" class="btn btn-blue-ml px-4" :disabled="!disabledForm">Recuperar Senha</button>
      </div>
    </form>

  </div>
</template>

<script>
  import FloatingLabel from '@/components/FloatingLabel';

  export default {
    name: 'PasswordForm',

    data(){
      return {
        email: ''
      }
    },

    components: {
      FloatingLabel
    },

    computed: {
      disabledForm(){
        return this.$helpers.isEmail(this.email)
      }
    },

    methods: {
      submit(){
        this.$store.dispatch('user/passwordRecovery', {
          email: this.email,
          domain: `${location.host}/password-recovery`
        }).then( response => {

          if( response.error ){
            this.$swal("Uoops", "E-mail não cadastrado", "error")
          }else{
            this.$swal({
              title: '',
              text: 'Enviamos para seu e-mail instruções de como recuperar sua senha',
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'Fechar'
            }).then((result) => {
              if (result.value) {
                this.$store.commit('DEVISE_FORM', null);
              }
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss"></style>